import { useCallback, useEffect, useRef, useState } from "react";
import { Timer } from "@/components/Timer";
import { useCountdown } from "@/hooks/useCountdown";
import { countWords } from "@/lib/scoring";
import { StatusBadge } from "@/components/items/SpeakingItem";

export const ReconstructItem = ({ part, item, mode, onSubmit }) => {
  const [phase, setPhase] = useState("read");
  const [text, setText] = useState("");
  const textRef = useRef("");
  const doneRef = useRef(false);
  const areaRef = useRef(null);

  const submit = useCallback(() => {
    if (doneRef.current) return;
    doneRef.current = true;
    onSubmit({ text: textRef.current });
  }, [onSubmit]);

  const readLeft = useCountdown(part.readTime, phase === "read", () => setPhase("write"));
  const writeLeft = useCountdown(part.time, phase === "write", submit);
  useEffect(() => { if (phase === "write") areaRef.current?.focus(); }, [phase]);

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3"><StatusBadge phase={phase} />
          {mode === "practice" && phase === "read" && <button data-testid="reconstruct-skip-read-btn" onClick={() => setPhase("write")} className="rounded-full border border-slate-300 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-100">I'm ready to write</button>}
        </div>
        {phase === "read" ? <Timer left={readLeft} total={part.readTime} label="Reading time" /> : <Timer left={writeLeft} total={part.time} label="Writing time" />}
      </div>
      {phase === "read" ? (
        <p data-testid="reconstruct-passage" className="font-display text-xl leading-relaxed text-slate-800">{item.text}</p>
      ) : (
        <>
          <div className="rounded-lg border border-dashed border-slate-300 p-4 text-sm text-slate-400">The passage has been hidden. Reconstruct it in your own words.</div>
          <textarea ref={areaRef} data-testid="reconstruct-input" rows={7} value={text}
            onChange={(e) => { textRef.current = e.target.value; setText(e.target.value); }} onPaste={(e) => e.preventDefault()}
            className="w-full rounded-lg border border-slate-300 p-4 text-base text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Rewrite the passage…" />
          <div className="flex items-center justify-between">
            <span data-testid="reconstruct-word-count" className="font-mono text-xs text-slate-500">{countWords(text)} words</span>
            <button data-testid="item-submit-btn" onClick={submit} className="rounded-full bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-indigo-700">Submit</button>
          </div>
        </>
      )}
    </div>
  );
};
